export const getModulesConfig = (imageHandler, expanded = false, disable = {}) => {
    const basicToolbar = [
        ['bold', 'italic', 'underline'],
        [{'color': 'custom-picker'}, {'background': 'custom-picker'}],
        ['variableDropdown']
    ];

    const alignConfig = disable.alignLeft
        ? {'align': ['center', 'right', 'justify']}
        : {'align': []};

    const expandedToolbar = [
        [{'header': [1, 2, 3, 4, 5, 6, false]}],
        ['bold', 'italic', 'underline', 'strike'],
        [{'color': 'custom-picker'}, {'background': 'custom-picker'}],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'indent': '-1'}, {'indent': '+1'}],
        [alignConfig, {'direction': 'rtl'}],
        ['blockquote', 'code-block'],
        disable.video ? ['link', 'image'] : ['link', 'image', 'video'],
        ['emoji'],
        ['variableDropdown']
    ];

    return {
        toolbar: {
            container: expanded ? expandedToolbar : basicToolbar,
            handlers: expanded ? {
                image: imageHandler
            } : {}
        },
        'emoji-toolbar': expanded,
        'emoji-textarea': false,
        'emoji-shortname': expanded,
        history: {
            delay: 500,
            maxStack: 100,
            userOnly: true,
        }
    };
};

